import { useContext } from 'react';

import IconButton from '@mui/material/IconButton';
import { Box, Stack, Typography } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { SearchComponent } from '@/components/common/Search';

import './Header.css';
import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { useTranslation } from 'react-i18next';
import { ctxMessages } from '@/contexts/MessagesCtx';

export function Header() {
  const ctx = useContext(ctxMessages);
  const { t } = useTranslation();

  if (!ctx) return;

  function navigateBack() {
    ctx?.setThread(undefined);
  }

  if (isPhoneOrHighScreen() && ctx.thread) {
    return (
      <>
        <div className="chat-thread-header">
          <span>
            <IconButton onClick={navigateBack} sx={{ color: 'text.primary' }}>
              <ArrowBack />
            </IconButton>
          </span>
          <Stack>
            <Typography variant="h6">{ctx.thread.user.name}</Typography>
            <Typography variant="subtitle2" color="grey.600">
              {ctx.thread.user.description}
            </Typography>
          </Stack>
          <Box component="span" sx={{ flex: 1, textAlign: 'right' }} />
        </div>
      </>
    );
  } else {
    return (
      <>
        {!isPhoneOrHighScreen() && <Typography variant="h6">{t('chat.latestMessages')}</Typography>}
        <SearchComponent searchText={ctx.searchText} setSearchText={ctx.setSearchText} />
      </>
    );
  }
}
